
mutation purchaseCoinbaseOrderRequest($data: TransactionCoinbasePurchase) {
    purchaseCoinbaseOrderRequest(data: $data) 
}
